import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SettingsTab from './SettingsTab'

import { selectRole } from '../../../routing/fetchingfunction/user/user.reducer'

import { getGeneralSettings, hideSettingsTabsRoutes } from '../../../constants'

const Settings = () => {
  const location = useLocation()

  const role = useSelector(selectRole)

  const areTabsHidden = !!hideSettingsTabsRoutes.find((route) => location.pathname.includes(route))

  const generalSettingsContent = getGeneralSettings(role).map((generalSetting) => {
    return <SettingsTab key={generalSetting.link} setting={generalSetting} />
  })

  return (
    <div className="flex flex-col items-start w-full max-w-screen-xl mx-auto my-[20px] px-4 md:px-8 lg:px-16 xl:px-20">
      <div className="w-full flex flex-col lg:flex-row gap-6">
        <div className="w-full flex gap-[20px]">
          {!areTabsHidden && (
            <div className="w-[264px]">
              <div className="bg-[#FEEBDD] rounded-xl shadow-md p-[32px]">
                <h2 className="text-[#F67443] text-xl font-bold">General Settings</h2>

                <div className="flex flex-col gap-y-[12px] mt-[20px]">{generalSettingsContent}</div>
              </div>
            </div>
          )}

          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings
